import { Component,OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ServiceResponse } from 'src/app/models/service-response';
import { RoleService } from 'src/app/rest_services/role.service';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit, OnDestroy {

  rolesLoading: boolean = true;
  rolesSubscription!: Subscription;
  roles: Array<any> = [];

  tabs = ["DASH", "ACTION", "TEAM", "PROFIL", "VISITE", "CLIENT", "PARAMETRAGE"];
  group: any | any[]| null | undefined = [];

  constructor(private roleService: RoleService) { }

  ngOnInit(): void {
    this.getCompanyRoles();
  }

  getCompanyRoles(){
    this.rolesSubscription = this.roleService.getCompanyRoles().subscribe(
      (resp: ServiceResponse) => {
        if(resp.code == "bf025c4dcce776832c0d50903044d7f5") {
          this.roles = resp.roles;
          this.getRolesByPage(this.roles);
        }
       this.rolesLoading = false;
      },
      (err: any) => {
        console.log(err);
        this.rolesLoading = false;
      }
    );
  }

  getRolesByPage(roles: Array<any>){
    this.group = roles.reduce((r, a) => {
      let tab = a.name.split("_")[0]
      r[tab] = [...r[tab] || [], a];
      return r;
      }, {});
  }

  getTab(tab:string) {
    switch (tab) {
      case "DASH":
        return "Tableau de bord";
      case "VISITE":
        return "Visites";
      case "ACTION":
        return "Actions";
      case "CLIENT":
        return "Clients"
      case "TEAM":
        return "Équipe";
      case "PARAMETRAGE":
        return "Paramétrage";
      case "PROFIL":
        return "Profile";
      default:
        return tab;
    }
  }

  getTabIcon(tab:string) {
    switch (tab) {
      case "DASH":
        return "flaticon-computer-6";
      case "VISITE":
        return "flaticon-car-1";
      case "ACTION":
        return "flaticon-menu-list";
      case "CLIENT":
        return "flaticon-building-1"
      case "TEAM":
        return "flaticon-user-group-1";
      case "PARAMETRAGE":
        return "flaticon-setting-1";
      case "PROFIL":
        return "flaticon-user-1";
      default:
        return tab;
    }
  }

  ngOnDestroy(): void {
    this.rolesSubscription?.unsubscribe();
  }


}
